/**
 * Teclado numérico táctil.
 *
 * Es el único método de entrada garantizado en el terminal: puede no haber
 * teclado físico y el operario puede llevar guantes. Acepta además el teclado
 * físico y un lector de códigos de barras, que teclea rápido y termina en Enter.
 */
import { useEffect } from 'react';

export function Numpad({
  value,
  onChange,
  onSubmit,
  maxLength = 15,
  submitLabel = 'OK',
  disabled,
}: {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  maxLength?: number;
  submitLabel?: string;
  disabled?: boolean;
}) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key >= '0' && event.key <= '9') onChange((value + event.key).slice(0, maxLength));
      else if (event.key === 'Backspace') onChange(value.slice(0, -1));
      else if (event.key === 'Enter') onSubmit();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [value, onChange, onSubmit, maxLength]);

  const press = (digit: string) => {
    if (navigator.vibrate) navigator.vibrate(8);
    onChange((value + digit).slice(0, maxLength));
  };

  return (
    <div className="numpad">
      {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((digit) => (
        <button key={digit} className="numpad__key" onClick={() => press(digit)} disabled={disabled}>
          {digit}
        </button>
      ))}
      <button className="numpad__key numpad__key--del" onClick={() => onChange(value.slice(0, -1))} disabled={disabled}>
        Borrar
      </button>
      <button className="numpad__key" onClick={() => press('0')} disabled={disabled}>
        0
      </button>
      <button className="numpad__key numpad__key--ok" onClick={onSubmit} disabled={disabled || value.length === 0}>
        {submitLabel}
      </button>
    </div>
  );
}

export function PinDisplay({ length, placeholder }: { length: number; placeholder: string }) {
  return (
    <div className="pin-display">
      {length === 0 ? (
        <span className="pin-placeholder">{placeholder}</span>
      ) : (
        Array.from({ length }, (_, i) => <span key={i} className="pin-dot" />)
      )}
    </div>
  );
}
